import { render, staticRenderFns } from "./NegativeCommentReport.vue?vue&type=template&id=3c170f0a&scoped=true"
import script from "./NegativeCommentReport.vue?vue&type=script&lang=js"
export * from "./NegativeCommentReport.vue?vue&type=script&lang=js"
import style0 from "./NegativeCommentReport.vue?vue&type=style&index=0&id=3c170f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c170f0a",
  null
  
)

export default component.exports